import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, UsersIcon, StarIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <ClipboardListIcon className="w-8 h-8 text-amber-500" data-id="element-1611" />,
    title: 'Tell Us What You Need',
    description: 'Select your service type and describe your project. It only takes 60 seconds.',
    number: '1'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-amber-500" data-id="element-1612" />,
    title: 'Get Matched with Pros',
    description: 'We connect you with up to 4 vetted, local professionals who are ready to help.',
    number: '2'
  }, {
    icon: <StarIcon className="w-8 h-8 text-amber-500" data-id="element-1613" />,
    title: 'Compare & Hire',
    description: 'Review quotes, check ratings, and choose the pro that fits your budget and timeline.',
    number: '3'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-1614">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1615">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1616">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block py-1.5 px-4 rounded-full bg-amber-50 text-amber-600 text-sm font-bold tracking-wider uppercase mb-4 border border-amber-200" data-id="element-1617">
            Simple Process
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-5 tracking-tight" data-id="element-1618">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-slate-500" data-id="element-1619">
            Get matched with the right pro in minutes
          </motion.p>
        </div>

        <div className="relative" data-id="element-1620">
          {/* Desktop Connector Line */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] z-0" data-id="element-1621">
            <div className="h-[2px] bg-slate-200 w-full relative" data-id="element-1622">
              <motion.div initial={{
              scaleX: 0,
              opacity: 0
            }} whileInView={{
              scaleX: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.2,
              delay: 0.5,
              ease: 'easeInOut'
            }} className="absolute inset-0 bg-amber-300 origin-left" data-id="element-1623" />
            </div>
          </div>

          <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} data-id="element-1624">
            {steps.map((step, index) => <motion.div key={index} variants={itemVariants} className="relative flex flex-col items-center text-center group" data-id="element-1625">
                {/* Icon Container */}
                <div className="w-24 h-24 rounded-full bg-amber-50 flex items-center justify-center mb-8 relative border-4 border-white shadow-lg group-hover:shadow-xl group-hover:scale-105 transition-all duration-300" data-id="element-1626">
                  {step.icon}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-amber-500 text-white font-bold text-sm flex items-center justify-center border-3 border-white shadow-md" data-id="element-1627">
                    {step.number}
                  </div>
                </div>

                {/* Text Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1628">
                  {step.title}
                </h3>
                <p className="text-slate-500 leading-relaxed max-w-xs" data-id="element-1629">
                  {step.description}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}